<template>
  <div class="travelCardDetail">
    <template v-if="isShowLoading">
      <loading></loading>
    </template>
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem>
          <router-link :to="{ name: 'TravelCard' }">旅游卡</router-link>
        </BreadcrumbItem>
        <BreadcrumbItem class="currPage">旅游卡详情</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="ticket_wrap">
      <h1
        :style="{
          borderBottom: '1px solid #ececec',
          paddingBottom: '20px',
          marginTop: '20px',
        }"
      >
        {{ info.name }}
      </h1>
      <div class="wrap_info">
        <div class="img"><img :src="info.imageAddr" art="图片加载失败" /></div>
        <div class="info">
          <h2><span class="icon_travelcard"></span>{{ info.name }}</h2>
          <h3>【旅游卡介绍】</h3>
          <p>
            <span>费用说明：</span> 广元旅游卡年费100元/人/年；手续费5元/人/次。
          </p>
          <p>
            <span>旅游卡有效期:</span>
            {{
              info.periodType === 0
                ? info.periodNumber + "年"
                : info.periodType === 1
                ? info.periodNumber + "月"
                : info.periodNumber + "天"
            }}
          </p>
          <p><span>旅游卡权益:</span> {{ info.descpt }}</p>
          <p>
            <span>通用时间:</span>
            {{
              info.usePeriod == -1
                ? "不限制"
                : info.usePeriod == 0
                ? "周六周日不能使用"
                : "节假日不能使用"
            }}
          </p>
          <p v-if="info.timesFlag !== -1">
            <span>有效次数:</span> {{ info.effectiveTimes }}
          </p>
          <p>
            <span>银行卡购买权限:</span>
            {{ info.bankCardFlag === -1 ? "不限制" : "限制" }}
          </p>
          <p>
            <span>身份证购买权限:</span>
            {{
              info.identityCardFlag === -1
                ? "不限制"
                : info.identityCardFlag === 0
                ? "限制"
                : ""
            }}
          </p>
          <p><span>包括景点:</span> {{ info.scenics || "" }}</p>
          <hr :style="{ borderBottom: '1px dashed #ccc' }" />
          <p :style="{ textAlign: 'right', margin: '12px 10px' }">
            <span :style="{ color: '#FF7F0D', marginRight: '30px' }"
              >￥<span :style="{ fontSize: '25px' }"
                >{{ info.price && info.price.toFixed(2) }}元</span
              ></span
            >
            <Button type="primary" @click="payNow" :disabled="status">
              {{ status ? "已购买" : "立即购买" }}
            </Button>
          </p>
          <!-- 优惠券 -->
          <div id="coupon" v-if="showCoupon">
            <div id="couponLeft">
              <dl>
                <dt>
                  <i>¥</i>
                  <span
                    :class="couponDetail.moneyStyle"
                    v-text="couponDetail.discountedPrice"
                  ></span>
                </dt>
                <dd>
                  <p>满{{ couponDetail.preferentialAmount }}元使用</p>
                  <p>
                    {{ couponDetail.startAvailableTime.split("-").join("") }}-{{
                      couponDetail.endAvailableTime.split("-").join("")
                    }}有效
                  </p>
                  <div>
                    <span :title="couponDetail.preferentialName">{{
                      couponDetail.preferentialName
                    }}</span>
                  </div>
                </dd>
              </dl>
            </div>
            <div id="couponRight" @click="getCoupon">
              <span v-text="getCouponText"></span>
              <Icon type="ios-arrow-down" />
            </div>
          </div>
        </div>
      </div>
      <h1 v-if="travelCard.length > 0">热销精选</h1>
      <div class="tickets" v-if="travelCard.length > 0">
        <travelcardmodel
          v-for="(item, index) in travelCard"
          :key="index"
          v-if="index < 4"
          :item="item"
          :index="index"
          :isshowlabel="true"
          @gotobuy="gotobuy"
        />
      </div>
      <div :style="{ textAlign: 'right', marginBottom: '32px' }">
        <router-link :to="{ name: 'TravelCard' }">浏览更多景区>> </router-link>
      </div>
    </div>
    <Modal
      v-model="writePersonalData"
      width="850"
      :footer-hide="footerHide"
      class-name="write-personal-data-style"
    >
      <!-- 工作、经商、务工 -->
      <!-- 广元就读的大中专院校学生 -->
      <p class="headTitle">请选择您在广元的身份信息</p>
      <RadioGroup v-model="optionChecked">
        <div>
          <Radio label="working"><span v-show="false">working</span></Radio>
          <span :class="optionChecked">工作、经商、务工</span>
        </div>
        <div>
          <Radio label="student"><span v-show="false">student</span></Radio>
          <span :class="optionChecked === 'working' ? 'student' : 'working'"
            >广元就读的大中专院校学生</span
          >
        </div>
      </RadioGroup>
      <div>
        <span class="descTitle optionTitle">公司/院校名称</span>
        <Input
          v-model="identityDesc"
          :maxlength="maxlength"
          type="textarea"
          placeholder="必填，限30个字"
          style="width: 489px"
        />
        <p id="descTips">
          温馨提示：请填写真实的工作单位和院校信息，否则发卡方有权收回旅游卡所有权益，该产品的最终解释权归易旅通平台所有。
        </p>
        <div id="uploadTips">
          <p>请按照以下提示，上传资料：</p>
          <p>1、党政企事业单位工作人员提供单位证明；</p>
          <p>2、学生提供学生证或学校证明；</p>
          <p>3、随迁户提供所在社区证明；</p>
          <p>4、工商及小微企业从业人员提供营业执照证明和工资证明；</p>
          <p>
            5、短期（一年以上）在广元务工人员提供所在单位（在广元注册的企事业单位）工作证明。
          </p>
          <!-- <div class="upload-list" v-for="item in uploadList" :key="item"> -->
          <div style="display: inline-block" v-if="uploadList.length > 0">
            <div class="upload-list" v-for="item in uploadList" :key="item">
              <img :src="item.url" />
              <div class="upload-list-cover">
                <Icon
                  type="ios-trash-outline"
                  @click.native="handleRemove(item)"
                ></Icon>
              </div>
            </div>
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="800"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :on-success="handleSuccess"
            :data="uploadParams"
            action="/sys/fileUpload/v1/uploadPic"
          >
            <div style="width: 58px; height: 58px; line-height: 58px">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          <div @click="showExampleImg" class="exampleButton">参考模板</div>
          <div v-if="showUseCoupon" id="showUseCoupon">
            <Checkbox
              v-model="useCoupon"
              ref="useCouponCheckbox"
              :disabled="useCouponDisabled"
              >使用优惠券，{{ couponInfor.preferential_rule }}</Checkbox
            >
          </div>
        </div>
        <button id="postPersonalSubmit" @click="postPersonalData">
          确认提交
        </button>
        <div v-if="showExample" class="exampleZoon" @click="closeExampleImg">
          <div class="exampleContent">
            <div class="exampleTitle">工作证明（模板）</div>
            <div>兹有我单位_____（同志），身份证号码：_____________</div>
            <div>自__年__月在我公司_____部门工作，特此证明。</div>
            <div class="exampleData">
              <div>单位名称（盖章）：______________</div>
              <div>日期：___________</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import travelcardmodel from "./travelCardmodel";
export default {
  components: {
    travelcardmodel,
  },
  data() {
    return {
      alertTip: "66666",
      status: false,
      isShowLoading: false,
      css_detail: {
        position: "relative",
        left: "160px",
        bottom: "20px",
      },
      articleId: this.$route.query.id,
      info: {},
      travelCard: [],
      // 个人信息弹窗
      writePersonalData: false,
      optionChecked: "working",
      identityDesc: "",
      footerHide: true,
      maxlength: 30,
      uploadImgUrl: "/sys/fileUpload/v1/uploadPic",
      uploadParams: {
        access_token: sessionStorage.getItem("name"),
      },
      defaultList: [],
      uploadList: [],
      showCoupon: false, // 是否显示优惠券
      couponDetail: {}, //
      showUseCoupon: false, //是否可以使用优惠券
      dateTime: new Date(),
      useCoupon: false,
      couponInfor: null, //存放可使用的优惠券
      getCouponText: sessionStorage.getItem("getCouponText")
        ? sessionStorage.getItem("getCouponText")
        : "立即领取",
      showExample: false,
      arr: [],
    };
  },
  created() {
    this.queryCurrentCoupon();
  },
  mounted() {
    this.gettravelDetail();
    this.gettravellist();
  },
  computed: {
    // 点击优惠券,当选中日期日期大于优惠期日期且不满足金额时候，disabled为true，且如果已勾选的，取消勾选状态；
    // 当满足上述条件时，disabled为false
    useCouponDisabled() {
      let m =
        this.dateTime.getMonth() < 9
          ? "0" + String(this.dateTime.getMonth() + 1)
          : this.dateTime.getMonth() + 1;
      let d =
        this.dateTime.getDate() < 10
          ? "0" + String(this.dateTime.getDate())
          : this.dateTime.getDate();
      let choiceTime = this.dateTime.getFullYear() + "-" + m + "-" + d;
      if (
        this.info.price >= this.couponInfor.preferential_amount &&
        Date.parse(choiceTime) >=
          Date.parse(this.couponInfor.start_available_time) &&
        Date.parse(choiceTime) <=
          Date.parse(this.couponInfor.end_available_time)
      ) {
        return false;
      } else {
        if (this.useCoupon === true) {
          this.useCoupon = false;
        }
        return true;
      }
    },
  },
  methods: {
    // 根据景区id获取当天可领取的优惠券
    queryCurrentCoupon() {
      this.$http
        .get(`${this.baseURL}/ticket/coupon/v1/queryCurrentCoupons`, {
          params: {
            //在卡列表中只能查到cardId,没有景区ID，目前写死状态
            iscenicid: "0",
            days: new Date().format("yyyy-MM-dd"),
          },
        })
        .then((res) => {
          // applicability: 1 // 适用范围
          // approvalStatus: 1 // 审核状态
          // cStatus: 1 // 优惠券状态
          // changeTheTime: null // 修改时间
          // cid: "1166190474831462400" // 主键
          // createTime: "2019-08-27 11:27:30" // 创建时间
          // creator: "园博园管理员" // 创建人
          // discountedPrice: 1 // 优惠金额
          // endAvailableTime: "2019-08-30" // 结束领取时间
          // endReceiveTime: "2019-08-30" // 使用结束时间
          // icompanyinfoid: 26 // 企业ID
          // limitTheNumber: 1 // 限制领取数量
          // modifier: null // 修改人
          // preferentialAmount: 100 // 优惠所需金额
          // preferentialName: "荆州门票优惠券" // 优惠券名称
          // preferentialNo: "1166227562327048192" // 优惠券编号
          // preferentialRule: "满100元减1元" // 优惠规则
          // preferentialType: 1 // 优惠券类别
          // productType: "1" // 产品类别
          // productTypeName: null //
          // sceneryName: null //
          // scenerySpotId: 38 // 景区ID
          // startAvailableTime: "2019-08-27" // 开始领取时间
          // startReceiveTime: "2019-08-27" // 开始使用时间
          // usageLimit: 1 // 使用限制
          // userType: 1 // 用户类别
          if (res.data.code === 200 && res.data.data) {
            this.showCoupon = true;
            let money = res.data.data.discountedPrice.toString();
            let count = money.indexOf(".") === -1 ? 0 : 1;
            let numLength = money.length - count;
            res.data.data.moneyStyle =
              numLength < 3
                ? ""
                : numLength === 3
                ? "moneyStyle25"
                : "moneyStyle20";
            this.couponDetail = Object.freeze(res.data.data);
          }
        });
    },
    // 领取优惠券
    getCoupon() {
      if (!sessionStorage.getItem("name")) {
        const _this = this;
        this.$Modal.confirm({
          title: "温馨提示",
          content: "请登录后再领取优惠券",
          onOk() {
            _this.$router.push({ name: "login" });
          },
          onCancel() {
            return false;
          },
        });
      } else {
        // sessionStorage.getItem("getCouponText")代表已领取了该优惠券
        const params = this.QS.stringify({
          couponId: this.couponDetail.cid,
          usid: sessionStorage.getItem("userName"),
        });
        this.$http
          .post(`${this.baseURL}/ticket/coupon/v1/collectCoupons?${params}`)
          .then((res) => {
            if (res.data.code === 200) {
              this.getCouponText = "已领取";
              // this.$req.showMessageModal(this,res.data.msg,3);
              this.$req.showMessageModal(this, "领取优惠券成功", 3);
              sessionStorage.setItem("getCouponText", "已领取");
            } else if (res.data.code === 400) {
              let text = "";
              if (res.data.msg.includes("领取过")) {
                text = "领取过";
                this.getCouponText = text;
                this.$req.showMessageModal(this, res.data.msg, 1);
                sessionStorage.setItem("getCouponText", text);
              } else if (res.data.msg.includes("未到可领取时间")) {
                text = "未可领";
                this.getCouponText = text;
                this.$req.showMessageModal(this, res.data.msg, 1);
                sessionStorage.setItem("getCouponText", text);
              } else if (res.data.msg.includes("已过可领取时间")) {
                text = "已过期";
                this.getCouponText = text;
                this.$req.showMessageModal(this, res.data.msg, 1);
                sessionStorage.setItem("getCouponText", text);
              } else if (res.data.msg.includes("已领完")) {
                text = "已领完";
                this.getCouponText = text;
                this.$req.showMessageModal(this, res.data.msg, 1);
                sessionStorage.setItem("getCouponText", text);
              }
            } else {
              this.$req.showMessageModal(this, res.data.message, 1);
              sessionStorage.setItem("getCouponText", "不可领");
            }
          });
      }
    },
    // 查看可使用优惠券 是广元用户的时候，才会传参数
    queryAvailableCoupon(isAndHas) {
      if (sessionStorage.getItem("userName")) {
        const params = this.QS.stringify({
          access_token: sessionStorage.getItem("name"),
          usid: sessionStorage.getItem("userName"),
          // 旅游卡为99
          icrowdkindid: 99,
          orderAmount: 100000,
        });
        this.$http
          .get(
            `${this.baseURL}/ticket/coupon/v1/viewAvailableCoupons?${params}`
          )
          .then((res) => {
            if (res.data.msg === "success" && res.data.data.length > 0) {
              this.showUseCoupon = true;
              this.couponInfor = res.data.data[0];
              const _this = this;
              if (isAndHas) {
                this.$Modal.confirm({
                  title: "温馨提示",
                  content: `
                  <p>是否使用优惠券？</p>
                `,
                  onOk() {
                    _this.saveIsAndHasData(true);
                  },
                  onCancel() {
                    _this.saveIsAndHasData(false);
                  },
                });
              }
            } else {
              if (isAndHas) {
                this.saveIsAndHasData(false);
              }
            }
          });
      }
    },
    /**
     * 广元订单下单(guangYuanCoupon 是否使用了优惠券)
     **/
    saveIsAndHasData(guangYuanCoupon) {
      this.$http
        .get(
          `${this.lee}/tourcard/tourcard/v1/newVerifyIdCard?${this.QS.stringify(
            {
              access_token: sessionStorage.getItem("name"),
              usid: sessionStorage.getItem("userName"),
              cardId: this.articleId,
              url: `${window.location.origin}/#/my-personalUser/myTravelCard`,
              channelName: "易旅通", //'环球雅途',
              orderChannel: "PC",
              couponId: guangYuanCoupon ? this.couponInfor.cid : "",
            }
          )}`
        )
        .then((res) => {
          this.isShowLoading = false;
          const data = res.data;
          const _this = this;
          if (data.code === 200) {
            this.$router.push({
              path: "/payTravelCard",
              query: {
                id: this.articleId,
                tradeNo: data.data.tradeNo,
                orderID: data.data.orderID,
                yhamnt: data.data.yhamnt,
              },
            });
          } else {
            this.$req.showMessageModal(this, data.msg, 1);
          }
        });
    },
    /**
     * 获取旅游卡详情，
     **/
    gettravelDetail() {
      this.isShowLoading = true;
      this.$http
        .get(
          `${this.lee}/tourcard/tourcard/v1/getTourCard?${this.QS.stringify({
            access_token: sessionStorage.getItem("name"),
            cardId: this.articleId,
            usid: sessionStorage.getItem("userName"),
          })}`
        )
        .then((res) => {
          this.isShowLoading = false;
          var data = res.data;
          if (data.code === 200) {
            this.info = data.data.data;
            this.status = data.data.own === 1 ? true : false;
          } else {
            this.$req.showMessageModal(this, data.msg, 2);
          }
        });
    },
    /**
     * 获取旅游卡”热销精选“---旅游卡列表接口，
     **/
    async gettravellist() {
      this.isShowLoading = true;
      const res = await this.$api.get2(
        `${
          this.lee
        }/tourcard/tourcard/v1/getTourCardListByUserId?${this.QS.stringify({
          usid: sessionStorage.getItem("userName"),
        })}`
      );
      if (res.code === 200) {
        this.isShowLoading = false;
        this.travelCard = res.data && res.data.length > 0 ? res.data : [];
      } else {
        this.isShowLoading = false;
        this.$req.showMessageModal(this, data.data.msg, 2);
      }
    },
    /**
     * 旅游卡”热销精选“购买接口，既查看旅游卡详情，
     **/
    gotobuy(id) {
      this.$router.push({
        path: "/travelCardListDetail",
        query: { id },
      });
      this.articleId = id;
      this.gettravelDetail();
      window.scrollTo(0, 115);
    },
    // 删除已上传的图片
    handleRemove(file) {
      // console.log("删除已上传图片file",file);
      // console.log("this.$refs.upload.fileList",this.$refs.upload.fileList);
      // const fileList = this.$refs.upload.fileList;
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.uploadList = [];
      this.$refs.upload.fileList = [];
    },
    // 上传图片格式验证失败时的钩子函数
    handleFormatError(file) {
      this.$Modal.warning({
        title: "温馨提示",
        content:
          "文件：" + file.name + " 格式有误，请上传jpg、jpeg、png格式的图片",
      });
    },
    // 图片超出大小限制时的钩子函数
    handleMaxSize(file) {
      this.$Modal.warning({
        title: "温馨提示",
        content:
          "您上传的图片文件  " +
          file.name +
          " 超出大小限制，请上传不大于800KB的图片。",
      });
    },
    // 图片上传成功时的钩子函数
    handleSuccess(res, file) {
      if (res.code === 200 && res.data) {
        this.uploadList = [];
        this.$set(this.uploadList, 0, res.data.info);
        // console.log("this.defaultList ",this.defaultList)
        // console.log("this.uploadList",this.uploadList)
      } else {
        this.$req.showMessageModal(this, "上传失败", 2);
      }
    },
    /**
     * 立即购买，判断用户有没有购买权限---调用旅游卡创建订单接口
     * 有，跳转旅游卡购买支付页面
     * 没有，则不跳转，并做提示
     **/
    postPersonalData() {
      if (!this.optionChecked) {
        this.$req.showMessageModal(this, "请勾选您的身份信息", 1);
        return false;
      }
      let working = "";
      let student = "";
      if (this.optionChecked === "working") {
        working = 1;
        student = 0;
      } else if (this.optionChecked === "student") {
        working = 0;
        student = 1;
      }
      if (!this.identityDesc) {
        this.$req.showMessageModal(this, "请填写公司/院校名称", 1);
        return false;
      }
      if (this.uploadList.length === 0) {
        this.$req.showMessageModal(this, "请上传资料", 1);
        return false;
      }
      const params = working + ";" + student + ";" + this.identityDesc;
      this.$http
        .get(
          `${
            this.lee
          }/tourcard/tourcard/v1/saveTourCardOrder?${this.QS.stringify({
            desc: params,
            imgAddr: this.uploadList[0].url,
            usid: sessionStorage.getItem("userName"),
            cardId: this.articleId,
            url: `${window.location.origin}/#/my-personalUser/myTravelCard`,
            orderChannel: "PC",
            channelName: "易旅通", //'环球雅途',
            couponId:
              this.showUseCoupon && this.useCoupon ? this.couponInfor.cid : "",
          })}`
        )
        .then((res) => {
          const data = res.data;
          const _this = this;
          if (data.code === 400 || data.code != 200) {
            this.$req.showMessageModal(this, data.msg, 1);
          } else {
            this.$Modal.success({
              title: "温馨提示",
              content:
                "您提交工作证明后，工作人员将在二个工作日内（国家法定节假日除外）进行审核，请您前往旅游卡订单查询审核状态。",
              onOk: () => {
                _this.$router.go(-1);
              },
            });
            // this.$router.push({
            //   path: '/payTravelCard',
            //   query: {
            //     id: this.articleId,
            //     tradeNo: data.data.tradeNo,
            //     orderID: data.data.orderID
            //   }
            // })
          }
        });
    },
    payNow() {
      // this.$http.get(`${this.lee}/tourcard/tourcard/v1/verifyIdCard?${this.QS.stringify({
      this.$http
        .get(
          `${
            this.lee
          }/tourcard/tourcard/v1/verifyIsGuangyuan?${this.QS.stringify({
            access_token: sessionStorage.getItem("name"),
            usid: sessionStorage.getItem("userName"),
            cardId: this.articleId,
            // url: `${window.location.origin}/#/my-personalUser/myTravelCard`,
            // channelName: '易旅通',//'环球雅途',
            // orderChannel: 'PC'
          })}`
        )
        .then((res) => {
          this.isShowLoading = false;
          const data = res.data;
          const _this = this;
          if (data.code === 400 && data.msg === "nopass") {
            // this.working=false;
            // this.student=false;
            // this.identityDesc='';
            // this.writePersonalData=true;
            this.$Modal.confirm({
              title: "温馨提示",
              content: `
              <p>1、适用于为广元户籍市民；</p>
              <p>2、对口援建广元的浙江省和黑龙省户籍市民；</p>
              <p>3、省内灾后援建广元的地市州（宜宾、泸州、自贡、攀枝花）户籍市民；</p>
            `,
              onOk() {
                _this.working = false;
                _this.student = false;
                _this.identityDesc = "";
                _this.writePersonalData = true;
                _this.queryAvailableCoupon();
              },
              onCancel() {},
            });
          } else if (data.code !== 200 && data.code == 400) {
            this.$Modal.confirm({
              title: "温馨提示",
              content: data.msg,
              onOk() {
                _this.$router.push({ name: "my-bank-card" });
              },
              onCancel() {},
            });
          } else if (data.code === 201) {
            this.$req.showMessageModal(this, data.msg, 1);
          } else if (data.code === 202) {
            this.$http
              .get(
                `${
                  this.lee
                }/tourcard/tourcard/v1/saveTourCardOrder?${this.QS.stringify({
                  usid: sessionStorage.getItem("userName"),
                  cardId: this.articleId,
                  url: `${window.location.origin}/#/my-personalUser/myTravelCard`,
                  orderChannel: "PC",
                  channelName: "易旅通", //'环球雅途',
                  couponId:
                    this.showUseCoupon && this.useCoupon
                      ? this.couponInfor.cid
                      : "",
                })}`
              )
              .then((resData) => {
                const data = resData.data;
                const _this = this;
                if (data.code === 400 || data.code != 200) {
                  this.$req.showMessageModal(this, data.msg, 1);
                } else {
                  this.$Modal.success({
                    title: "温馨提示",
                    content: "下单成功,请前往支付页面进行支付",
                    onOk: () => {
                      this.$router.push({
                        path: "/payTravelCard",
                        query: {
                          id: this.articleId,
                          tradeNo: data.data.tradeNo,
                          orderID: data.data.orderID,
                        },
                      });
                    },
                  });
                }
              });
          } else if (data.code !== 200) {
            this.$req.showMessageModal(this, data.msg, 1);
          } else {
            // 是广元客户，查看是否有优惠券
            this.queryAvailableCoupon("1", data);
          }
        });
    },
    showExampleImg() {
      this.showExample = true;
    },
    closeExampleImg() {
      this.showExample = false;
    },
  },
};
</script>

<style lang="less" scoped>
.travelCardDetail {
  padding-bottom: 20px;
  .breadcrumb {
    width: 1200px;
    margin: 0 auto;
    line-height: 50px;
    margin-bottom: 10px;
  }
  .ticket_wrap {
    background: #fff;
    width: 1200px;
    margin: 0 auto 101px;
    padding: 10px 35px;
  }
}
// 头部信息
.wrap_info {
  width: 100%;
  border-radius: 5px;
  border-bottom: 1px solid #eee;
  .img,
  .info {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    width: 665px;
  }
  .img {
    width: 445px;
    height: 320px;
    border: 1px solid #ccc;
    margin-left: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    padding: 20px 20px 0 20px;
    h2 {
      margin-bottom: 20px;
      color: #4e81f0;
      font-size: 16px;
      vertical-align: middle;
      span {
        vertical-align: middle;
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url("../../../../assets/icon_travelcard.png") no-repeat
          center;
      }
    }
    h3 {
      margin-bottom: 10px;
      margin-left: 20px;
    }
    p {
      margin-bottom: 10px;
      margin-left: 40px;
      color: #5e5e60;
      font-weight: 700;
      font-size: 14px;
      span {
        font-weight: 400;
        font-size: 12px;
      }
      button {
        a {
          color: #fff;
        }
      }
    }
    // 优惠券
    #coupon {
      position: absolute;
      bottom: 70px;
      right: 20px;
      height: 64px;
      width: 270px;
      display: flex;
      #couponLeft {
        height: 64px;
        width: 221px;
        background: url("../../../../assets/icon_yhxx_01.png") no-repeat 0 0;
        background-size: 100% 100%;
        dl {
          padding: 4px 0 4px 8px;
          dt,
          dd {
            display: inline-block;
            color: #fff;
          }
          dt {
            font-weight: 600;
            text-shadow: 0 2px 4px #da7100;
            width: 60px;
            height: 39px;
            i {
              font-style: normal;
              font-size: 13px;
            }
            span {
              display: inline-block;
              font-size: 30px;
            }
            .moneyStyle25 {
              font-size: 25px;
            }
            .moneyStyle20 {
              font-size: 20px;
            }
          }
          dd {
            font-size: 12px;
            margin-left: 5px;
            width: 148px;
            p {
              margin-bottom: 0px;
              margin-left: 0px;
              font-size: 12px;
              color: #fff;
              line-height: 18px;
              &:nth-of-type(1) {
                border-bottom: 1px dashed #fff;
              }
            }
            div {
              width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              span {
                display: inline-block;
                background: #fff;
                color: #fc8827;
                padding: 0 4px;
              }
            }
          }
        }
      }
      #couponRight {
        height: 64px;
        width: 49px;
        background: url("../../../../assets/icon_yhxx_02.png") no-repeat 0 0;
        background-size: 100% 100%;
        cursor: pointer;
        span {
          display: inline-block;
          width: 24px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #ff7600;
          margin: 12px 12px 0 13px;
          text-align: center;
        }
        i {
          color: #ff7600;
          font-size: 16px;
          margin: 0 17px 9px 17px;
        }
      }
    }
  }
}
// 热点推荐
h1 {
  margin: 60px 0 10px 0;
}
.tickets {
  font-size: 12px;
  border-top: 1px solid #eee;
  border-radius: 2px;
  padding-top: 20px;
}

// 填写个人信息弹窗
/deep/.write-personal-data-style {
  .ivu-modal {
    .ivu-modal-body {
      width: 100%;
      padding: 36px 128px 99px 127px;
      .headTitle {
        font-size: 18px;
        color: #171725;
        text-align: center;
        margin-bottom: 78px;
      }
      .optionTitle {
        display: inline-block;
        font-size: 14px;
        color: #171725;
      }
      .workingTitle,
      .studentTitle {
        width: 572px;
        margin-bottom: 25px;
        margin-left: 5px;
      }
      .working {
        width: 572px;
        margin-bottom: 25px;
        margin-left: 5px;
        display: inline-block;
        font-size: 14px;
        color: #171725;
      }
      .student {
        width: 572px;
        margin-bottom: 25px;
        margin-left: 5px;
        display: inline-block;
        font-size: 14px;
        color: #999999;
      }
      .descTitle {
        width: 106px;
      }
      .ivu-radio-wrapper {
        margin: 0;
        vertical-align: middle;
        .ivu-radio {
          margin-top: 1px;
          vertical-align: top;
        }
      }
      #descTips {
        width: 489px;
        margin: 13px 0 25px 106px;
        font-size: 12px;
        color: #fc5a5a;
      }
      #showUseCoupon {
        background: #fff;
        // border:1px solid #EDF0EF;
        margin-bottom: 40px;
        padding: 12px 0px;
        color: #fc8625;
        font-weight: 500;
        .ivu-checkbox-wrapper {
          .ivu-checkbox-inner {
            box-shadow: none;
          }
        }
      }
      .exampleButton {
        margin-top: 5px;
        font-size: 12px;
        color: #4f9efb;
        text-decoration: underline;
      }
      .exampleZoon {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        .exampleContent {
          width: 600px;
          background-color: #fff;
          padding: 0 20px;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: #000;
          font-size: 14px;
          .exampleTitle {
            margin-top: 30px;
            margin-bottom: 10px;
            font-size: 23px;
            font-weight: 600;
          }
          .exampleData {
            margin-top: 70px;
            margin-bottom: 30px;
            width: 100%;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
          }
        }
      }
      #uploadTips {
        font-size: 14px;
        color: #171725;
        .upload-list {
          display: inline-block;
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border: 1px solid transparent;
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          position: relative;
          box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
          margin-right: 4px;
          img {
            width: 100%;
            height: 100%;
          }
          &:hover {
            .upload-list-cover {
              display: block;
            }
          }
          .upload-list-cover {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.6);
            i {
              color: #fff;
              font-size: 20px;
              cursor: pointer;
              margin: 0 2px;
            }
          }
        }
        .ivu-upload {
          display: inline-block;
          .ivu-upload {
            background: #fff;
            border: 1px dashed #dcdee2;
            border-radius: 4px;
            text-align: center;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            transition: border-color 0.2s ease;
          }
        }
      }
      #postPersonalSubmit {
        background: #4b7ff0;
        border-radius: 6px;
        border-radius: 6px;
        width: 160px;
        height: 40px;
        color: #fff;
        border: none;
        margin: 57px 0 0 435px;
      }
    }
  }
}
</style>
<style lang="less">
</style>
